// extracted by mini-css-extract-plugin
export default {"root":"ModalActions_root__VPO7F"};